module.exports = __webpack_public_path__ + "media/images/gateway/go-577e127d8a4fcbf01df43e42fabb7678.jpg";